"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const groupBy_1 = tslib_1.__importDefault(require("lodash/groupBy"));
const userQueryHelpers_1 = require("./common/userQueryHelpers");
const getCustomPropertiesTermsQuery = (id, fieldValues) => {
    return {
        nested: {
            path: 'customProperties',
            query: {
                bool: {
                    must: [
                        {
                            term: {
                                'customProperties.id': id
                            }
                        },
                        {
                            terms: {
                                'customProperties.values.keyword': fieldValues
                            }
                        }
                    ]
                }
            }
        }
    };
};
const getCustomPropertiesRangeQuery = (id, lte, gte) => {
    return {
        nested: {
            path: 'customProperties',
            query: {
                bool: {
                    must: [
                        {
                            term: {
                                'customProperties.id': id
                            }
                        },
                        {
                            range: {
                                'customProperties.values.keyword': {
                                    lte,
                                    gte
                                }
                            }
                        }
                    ]
                }
            }
        }
    };
};
function getElasticsearchQueryForCustomProperties(filters) {
    if (filters.length > 0) {
        const groupedFilters = groupBy_1.default(filters, 'type');
        const query = { bool: {} };
        Object.keys(groupedFilters).forEach(type => {
            if (!query.bool.must) {
                query.bool.must = [];
            }
            switch (type) {
                case 'must':
                    query.bool.must = query.bool.must.concat(groupedFilters[type].map((filter) => getCustomPropertiesTermsQuery(filter.id, filter.values)));
                    break;
                case 'range':
                    query.bool.must = query.bool.must.concat(groupedFilters[type].map((filter) => getCustomPropertiesRangeQuery(filter.id, filter.lte, filter.gte)));
                    break;
            }
        });
        return {
            query
        };
    }
    return {};
}
function getUserIdsAndUniqueIdsFromCustomProperties(filters) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const _source = { includes: ['_id', 'uniqueId'] };
        const body = getElasticsearchQueryForCustomProperties(filters);
        if (Object.keys(body).length > 0) {
            const query = {
                size: 1000,
                _source,
                body
            };
            // Fetching the first batch of users using query and getting scrollId
            const elasticsearchResult = yield userQueryHelpers_1.getUsersUsingQuery(query, '30s');
            const { scrollId, total } = elasticsearchResult;
            // Fetching remaing batch of users using scroll
            const users = yield userQueryHelpers_1.fetchFromScroll({
                total,
                scrollId,
                users: elasticsearchResult.users
            });
            return { users, total: users.length };
        }
        return { users: [], total: 0 };
    });
}
exports.getUserIdsAndUniqueIdsFromCustomProperties = getUserIdsAndUniqueIdsFromCustomProperties;
//# sourceMappingURL=getUserIdsAndUniqueIdsFromCustomProperties.js.map